// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_evidence.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { GetRfiEvidenceStateResponse as GetRfiEvidenceStateResponse$1, ResolveRfiEvidenceContextResponse as ResolveRfiEvidenceContextResponse$1, RfiEvidenceDraft, RfiEvidencePublication, RfiEvidenceSource } from "../../datagateway/v1/rfi_evidence_pb";
/**
 * @generated from message mono.projectdata.v1.RegisterRfiManualDraftRequest
 */ export class RegisterRfiManualDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegisterRfiManualDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterRfiManualDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterRfiManualDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterRfiManualDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 2;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterRfiManualDraftRequest, "runtime", proto3);
_define_property(RegisterRfiManualDraftRequest, "typeName", "mono.projectdata.v1.RegisterRfiManualDraftRequest");
_define_property(RegisterRfiManualDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RegisterRfiManualDraftResponse
 */ export class RegisterRfiManualDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegisterRfiManualDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterRfiManualDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterRfiManualDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterRfiManualDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterRfiManualDraftResponse, "runtime", proto3);
_define_property(RegisterRfiManualDraftResponse, "typeName", "mono.projectdata.v1.RegisterRfiManualDraftResponse");
_define_property(RegisterRfiManualDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiDraftRequest
 */ export class ReviewRfiDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiDraftRequest, "runtime", proto3);
_define_property(ReviewRfiDraftRequest, "typeName", "mono.projectdata.v1.ReviewRfiDraftRequest");
_define_property(ReviewRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiDraftResponse
 */ export class ReviewRfiDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiDraftResponse, "runtime", proto3);
_define_property(ReviewRfiDraftResponse, "typeName", "mono.projectdata.v1.ReviewRfiDraftResponse");
_define_property(ReviewRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideRfiDraftRequest
 */ export class DecideRfiDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: bytes reviewed_content = 5;
   */ _define_property(this, "reviewedContent", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRfiDraftRequest, "runtime", proto3);
_define_property(DecideRfiDraftRequest, "typeName", "mono.projectdata.v1.DecideRfiDraftRequest");
_define_property(DecideRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewed_content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideRfiDraftResponse
 */ export class DecideRfiDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidencePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRfiDraftResponse, "runtime", proto3);
_define_property(DecideRfiDraftResponse, "typeName", "mono.projectdata.v1.DecideRfiDraftResponse");
_define_property(DecideRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: RfiEvidencePublication
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RenderRfiOutwardRequest
 */ export class RenderRfiOutwardRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenderRfiOutwardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenderRfiOutwardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenderRfiOutwardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenderRfiOutwardRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenderRfiOutwardRequest, "runtime", proto3);
_define_property(RenderRfiOutwardRequest, "typeName", "mono.projectdata.v1.RenderRfiOutwardRequest");
_define_property(RenderRfiOutwardRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RenderRfiOutwardResponse
 */ export class RenderRfiOutwardResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenderRfiOutwardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenderRfiOutwardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenderRfiOutwardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenderRfiOutwardResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidencePublication publication = 1;
   */ _define_property(this, "publication", void 0), /**
   * @generated from field: bytes content = 2;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string exclusion_reason = 3;
   */ _define_property(this, "exclusionReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenderRfiOutwardResponse, "runtime", proto3);
_define_property(RenderRfiOutwardResponse, "typeName", "mono.projectdata.v1.RenderRfiOutwardResponse");
_define_property(RenderRfiOutwardResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: RfiEvidencePublication
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 3,
            name: "exclusion_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveRfiEvidenceContextRequest
 */ export class ResolveRfiEvidenceContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRfiEvidenceContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRfiEvidenceContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRfiEvidenceContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRfiEvidenceContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceSource source = 4;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRfiEvidenceContextRequest, "runtime", proto3);
_define_property(ResolveRfiEvidenceContextRequest, "typeName", "mono.projectdata.v1.ResolveRfiEvidenceContextRequest");
_define_property(ResolveRfiEvidenceContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "message",
            T: RfiEvidenceSource
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveRfiEvidenceContextResponse
 */ export class ResolveRfiEvidenceContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRfiEvidenceContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRfiEvidenceContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRfiEvidenceContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRfiEvidenceContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ResolveRfiEvidenceContextResponse context = 1;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRfiEvidenceContextResponse, "runtime", proto3);
_define_property(ResolveRfiEvidenceContextResponse, "typeName", "mono.projectdata.v1.ResolveRfiEvidenceContextResponse");
_define_property(ResolveRfiEvidenceContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: ResolveRfiEvidenceContextResponse$1
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiEvidenceStateRequest
 */ export class GetRfiEvidenceStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEvidenceStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEvidenceStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEvidenceStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEvidenceStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEvidenceStateRequest, "runtime", proto3);
_define_property(GetRfiEvidenceStateRequest, "typeName", "mono.projectdata.v1.GetRfiEvidenceStateRequest");
_define_property(GetRfiEvidenceStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiEvidenceStateResponse
 */ export class GetRfiEvidenceStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEvidenceStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEvidenceStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEvidenceStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEvidenceStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetRfiEvidenceStateResponse state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEvidenceStateResponse, "runtime", proto3);
_define_property(GetRfiEvidenceStateResponse, "typeName", "mono.projectdata.v1.GetRfiEvidenceStateResponse");
_define_property(GetRfiEvidenceStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: GetRfiEvidenceStateResponse$1
        }
    ]));
